export const homePath = (role) => (role === "admin" ? "/admin/dashboard" : role === "teacher" ? "/teacher" : "/student");
